<template>
  <div class="modal-wrapper">
    <div class="modal-backdrop"></div>
    <div class="modal-inner">
      <div class="edit-popup edit-popup--email-template">
        <div class="edit-popup__header">
          <div class="edit-popup__title">
            {{ currentEmailTemplate.type === 'new' ? 'Create' : 'Edit' }} a Template
          </div>
          <div @click="closeModalEmailTemplate" class="edit-popup__close">
            <svg width="1em" height="1em" class="icon icon-close">
              <use
                  xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
            </svg>
          </div>
        </div>
        <div class="edit-popup__name">
          <div class="template-name">
            <span>Template Name:</span>
            <div
                class="row_input"
                :class="[
                    'form-control-wrap',
                    {'is-error': false},
                  ]">
              <input
                  type="text"
                  v-model="currentEmailTemplate.name"
                  Placeholder="Template Name"
                  class="form-control"
              />
            </div>
          </div>
          <div class="template-name">
            <span>Template <br> Tittle / Theme:</span>
            <div
                class="row_input"
                :class="[
                    'form-control-wrap',
                    {'is-error': false},
                  ]">
              <input
                  type="text"
                  v-model="currentEmailTemplate.texts[lang.emailTemplateDescription].subject"
                  Placeholder="Template Tittle / Theme"
                  class="form-control"
              />
            </div>
          </div>
        </div>
        <div class="edit-popup__tags">
          <div
              class="edit-popup__tag"
              v-for="(type, index) in dataTypeEmailTemplate"
              :key="index"
              :class="['select-option__tag', {'is-selected__tag': currentEmailTemplate.tags
                    .map(item => item)
                    .includes(type.type)}]"
          >

            <label
                @click.prevent.stop="
                            () => {
                              if (
                                !currentEmailTemplate.tags
                                  .map((item) => item)
                                  .includes(type.type)
                              ) {
                                currentEmailTemplate.tags.push(type.type)
                              } else {
                                currentEmailTemplate.tags = currentEmailTemplate.tags.filter(
                                  (i) => !(i === type.type)
                                )
                              }
                            }
                          "
            >

              <input
                  type="checkbox"
                  :checked="
                    currentEmailTemplate.tags
                    .map(item => item)
                    .includes(type.type)
                  "
                  @click.prevent.stop
              />

              <img
                  v-if="type.type === 'CLIMBING'"
                  src="/images/useful/svg/clients-icon1.svg"
                  alt="CLIMBING"
              />
              <img
                  v-if="type.type === 'SAFARI'"
                  src="/images/useful/svg/clients-icon2.svg"
                  alt="SAFARI"
              />
              <img
                  v-if="type.type === 'ISLAND'"
                  src="/images/useful/svg/clients-icon3.svg"
                  alt="ISLAND"
              />
              <img
                  v-if="type.type === 'EXCURSION'"
                  src="/images/useful/svg/clients-icon4.svg"
                  alt="EXCURSION"
              />

              <span>{{type.name}}</span>


            </label>

          </div>
        </div>
        <div class="edit-popup__text">
          <div class="js-ckeditor">
            <editor

                :editor="editor"
                v-model="currentEmailTemplate.texts[lang.emailTemplateDescription].text"
                @focus="isEditFlag = true"
                :config="editorConfig"
            >
            </editor>
          </div>
          <div class="languages-groups">
            <label
                class="np-detail-collapse__lang np-detail-collapse__lang_checkbox"
                @click="lang.emailTemplateDescription = 'EN'">
              <input
                  type="radio"
                  name="lanuage"
                  :checked="lang.emailTemplateDescription === 'EN'" />
              <div class="np-detail-collapse__lang__icon">
                <svg width="1em" height="1em" class="icon icon-gb">
                  <use
                      xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-gb"></use>
                </svg>
              </div>
              <span class="np-detail-collapse__lang__text">English</span>
            </label>
            <label
                class="np-detail-collapse__lang np-detail-collapse__lang_checkbox"
                @click="lang.emailTemplateDescription = 'RU'">
              <input
                  type="radio"
                  name="lanuage"
                  :checked="lang.emailTemplateDescription === 'RU'" />
              <div class="np-detail-collapse__lang__icon">
                <svg width="1em" height="1em" class="icon icon-rus">
                  <use
                      xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-rus"></use>
                </svg>
              </div>
              <span class="np-detail-collapse__lang__text">Russian</span>
            </label>
            <label
                class="np-detail-collapse__lang np-detail-collapse__lang_checkbox"
                @click="lang.emailTemplateDescription = 'DE'">
              <input
                  type="radio"
                  name="lanuage"
                  :checked="lang.emailTemplateDescription === 'DE'" />
              <div class="np-detail-collapse__lang__icon">
                <svg width="1em" height="1em" class="icon icon-deu">
                  <use
                      xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-deu"></use>
                </svg>
              </div>
              <span class="np-detail-collapse__lang__text">Deutch</span>
            </label>
          </div>
        </div>
        <div class="edit-popup__btns">
          <div  v-if="currentEmailTemplate.type === 'new'" class=""></div>
          <div class="edit-popup__btn edit-popup__btn--delete" v-if="currentEmailTemplate.type === 'edit'">
            <button @click="deleteModalEmailTemplate(currentEmailTemplate)">
              <div class="form-control-action__icon icon--red">
                  <svg
                                                                  width="1em"
                                                                  height="1em"
                                                                  class="icon icon-close">
                                                                <use
                                                                    xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use></svg>
              </div>
              <span>Delete Template</span>
            </button>
          </div>
          <div class="edit-popup__btn">
            <button @click="closeModalEmailTemplate" class="btn btn--silver">
              <span>Cancel</span>
            </button>
            <button @click="changeEmailTemplate(currentEmailTemplate)" class="btn btn--green">
              <span>{{ currentEmailTemplate.type === 'new' ? 'Create' : 'Save' }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CKEditor from '@ckeditor/ckeditor5-vue2'
import ClassicEditor from "@/utilites/ckeditor";

export default {
  name: "ATModalEmailTemplateSettings",
  props: {
    currentEmailTemplate: {
      type: Object,
      required: true
    }
  },
  components: {editor: CKEditor.component},
  data() {
    return {
      editor: ClassicEditor,
      editorConfig: {
        placeholder: 'Write text',
      },
      isEditFlag: false,
      dataTypeEmailTemplate: [
        {name: 'FL1', type: 'FL1'},
        {name: 'FL2', type: 'FL2'},
        {name: 'Climbing', type: 'CLIMBING'},
        {name: 'Safari', type: 'SAFARI'},
        {name: 'Excursion', type: 'EXCURSION'},
        {name: 'Island', type: 'ISLAND'},
        {name: 'Invoices', type: 'INVOICES'},
      ],
      dataTagsEmailTemplate: [],
      lang: {
        emailTemplateDescription: 'EN',
      },
    }
  },
  computed: {

  },
  methods: {
    closeModalEmailTemplate(){
      this.$emit('closeModalEmailTemplateOptions', false)
    },
    deleteModalEmailTemplate(email) {
      this.$emit('deleteModalEmailTemplateOptions', email)
      // this.closeModalEmailTemplate()
    },
    changeEmailTemplate(email){
      this.$emit('changeEmailTemplateOptions', email)
      this.closeModalEmailTemplate()
    }
  }
}
</script>

<style scoped>

</style>